import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import InputField from "../../InputField";
import exportImage from "../../../asset/Images";

export default function ExpensesView() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const { handleSubmit, control, watch, setValue } = useForm();

  const tableData = [
    {
      invoiceNo: "INV/056/24-25",
      customerName: "vignesh",
      siteName: "Adyar",
      mobileNo: "123456890",
      branch: "RASHI SPACE SOLUTION",
    },
    {
      invoiceNo: "INV/057/24-25",
      customerName: "Sabari raja",
      siteName: "Kelambakkam",
      mobileNo: "123456890",
      branch: "2k Virtual World",
    },
    {
      invoiceNo: "INV/058/24-25",
      customerName: "Ranjith",
      siteName: "Velachery",
      mobileNo: "123456890",
      branch: "RASHI SPACE SOLUTION",
    },
    {
      invoiceNo: "INV/059/24-25",
      customerName: "Prasanth",
      siteName: "Kelambakkam",
      mobileNo: "123456890",
      branch: "RASHI SPACE SOLUTION",
    },
    {
      invoiceNo: "INV/060/24-25",
      customerName: "Devi",
      siteName: "Adyar",
      mobileNo: "123456890",
      branch: "RASHI SPACE SOLUTION",
    },
    {
      invoiceNo: "INV/060/24-25",
      customerName: "Devi",
      siteName: "Adyar",
      mobileNo: "123456890",
      branch: "RASHI SPACE SOLUTION",
    },
    {
      invoiceNo: "INV/060/24-25",
      customerName: "Devi",
      siteName: "Adyar",
      mobileNo: "123456890",
      branch: "RASHI SPACE SOLUTION",
    },
    {
      invoiceNo: "INV/060/24-25",
      customerName: "Devi",
      siteName: "Adyar",
      mobileNo: "123456890",
      branch: "RASHI SPACE SOLUTION",
    },
    {
      invoiceNo: "INV/060/24-25",
      customerName: "Devi",
      siteName: "Adyar",
      mobileNo: "123456890",
      branch: "RASHI SPACE SOLUTION",
    },
    {
      invoiceNo: "INV/060/24-25",
      customerName: "Devi",
      siteName: "Adyar",
      mobileNo: "123456890",
      branch: "RASHI SPACE SOLUTION",
    },
    {
      invoiceNo: "INV/060/24-25",
      customerName: "Devi",
      siteName: "Adyar",
      mobileNo: "123456890",
      branch: "RASHI SPACE SOLUTION",
    },
  ];

  const overAllReportDetails = [
    {
      name: "OVERALL",
      value: "500",
      colorCode: "rgba(0, 184, 238, 0.3)",
      textColorCode: "rgba(0, 184, 238, 1)",
    },
    {
      name: "Paid",
      value: "19",
      colorCode: "rgba(1, 156, 80, 0.3)",
      textColorCode: "rgba(1, 156, 80, 1)",
    },

    {
      name: "Outstanding",
      value: "500",
      colorCode: "rgba(237, 52, 54, 0.3)",
      textColorCode: "rgba(237, 52, 54, 1)",
    },
  ];

  const [filteredData, setFilteredData] = useState(tableData);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredData
    ? filteredData?.slice(indexOfFirstRow, indexOfLastRow)
    : tableData?.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(
    filteredData
      ? filteredData?.length / rowsPerPage
      : tableData?.length / rowsPerPage
  );

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Handle search
  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);

    const filtered =
      tableData &&
      tableData?.filter((data) => {
        return (
          data?.invoiceNo?.toLowerCase().includes(value) ||
          data?.customerName?.toLowerCase().includes(value) ||
          data?.siteName?.toLowerCase().includes(value)
        );
      });
    setFilteredData(filtered);
  };

  return (
    <>
      <div className="screen_mainContainer">
        <div className="screen_InnerContainer">
          <header className="screen_headerContainer">
            <div className="header_title">Expenses</div>
            <div
              className="header_Btn_container"
              onClick={() => {
                navigate("/expenses/expensesAdd");
              }}
            >
              Add Expenses
            </div>
          </header>
          <section className="viewPageSectionContainer">

          <div className="reportMainContainer">
              {overAllReportDetails?.map((item, index) => {
                return (
                  <div className="overall-card">
                    <div className="overall-text">
                      <div
                        className="overall-label"
                        style={{ color: item.textColorCode }}
                      >
                        {item.name}
                      </div>
                      <div
                        className="overall-value"
                        style={{ color: item.textColorCode }}
                      >
                        {item.value}
                      </div>
                    </div>
                    <div
                      className="bg-shape1"
                      style={{ background: item.colorCode }}
                    ></div>
                    <div
                      className="bg-shape2"
                      style={{ background: item.colorCode }}
                    ></div>
                  </div>
                );
              })}
            </div>

            <div className="searchSelectMainContainer ">
              <div className="quotationInputSearch">
                <div className="searchInput">
                  <label className="searchInputLabel">Search</label>
                  <Controller
                    control={control}
                    name="Search"
                    render={(field) => (
                      <InputField
                        {...field}
                        type="text"
                        searchInputCss="searchInputCss"
                        onChange={handleSearch}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="quotationSelectSearch">
                <div className="selectContainer">
                  <div className="searchInput">
                    <Controller
                      control={control}
                      name="selectDate"
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <InputField
                          type="date"
                          searchSelectCss="searchSelectCss"
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="selectContainer">
                  <div className="searchInput">
                    <Controller
                      control={control}
                      name="selectBranch"
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <select
                          onChange={onChange}
                          value={value}
                          className="searchSelectCss"
                        >
                          <option value=""> --Select-- </option>
                          <option value="RASHI SPACE SOLUTION">
                            {" "}
                            RASHI SPACE SOLUTION{" "}
                          </option>
                          <option value="2k Virtual World">
                            {" "}
                            2k Virtual World{" "}
                          </option>
                        </select>
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="tableMainContainer">
              <table className="tableMain">
                <thead>
                  <tr className="tableHeadRow">
                    <td className="tableHeaderTxt ">Invoice No</td>
                    <td className="tableHeaderTxt ">
                      Purchase for (Customer Name)
                    </td>
                    <td className="tableHeaderTxt ">Branch</td>
                    <td className="tableHeaderTxt ">Material/Wage</td>
                    <td className="tableHeaderTxt ">Status</td>
                    <td
                      className="tableHeaderTxt "
                      style={{
                        width: "260px",
                      }}
                    >
                      Action
                    </td>
                  </tr>
                </thead>
                <tbody className="tableBody">
                  {false ? (
                    <>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <div className="loader"></div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </>
                  ) : currentRows?.length > 0 ? (
                    currentRows &&
                    currentRows?.map((item, index) => {
                      return (
                        <tr>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.invoiceNo}
                          </td>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.customerName}
                          </td>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.siteName}
                          </td>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.mobileNo}
                          </td>

                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                              color:
                                item?.status === "Outstanding"
                                  ? "red"
                                  : "green",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.status}
                          </td>
                          <td
                            className="tableDataTxt "
                            style={{
                              width: "260px",
                              height: "100%",
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                          >
                            <div className="d-flex gap-1 align-items-center">
                              <div className="actionBtn" onClick={() => {}}>
                                <img
                                  className="mb-1"
                                  src={exportImage?.editIcon}
                                  alt="editIcon"
                                />
                              </div>
                              <div className="actionBtn" onClick={() => {}}>
                                <img
                                  className="mb-1"
                                  src={exportImage?.deleteIcon}
                                  alt="deleteIcon"
                                />
                              </div>
                              <div className="actionBtn" onClick={() => {}}>
                                <img
                                  className="mb-1"
                                  src={exportImage?.duplicateIcon}
                                  alt="duplicateIcon"
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <p className="noDataFoundTxt">No Data Found</p>
                  )}
                </tbody>
              </table>
            </div>
          </section>
          <nav aria-label="Page navigation example" className="mt-2">
            <ul className="pagination justify-content-center">
              {/* Previous Button */}
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &laquo;
                </button>
              </li>

              {/* Page Numbers */}
              {Array?.from({ length: totalPages })?.map((_, index) => {
                const pageNumber = index + 1;
                const isActive = currentPage === pageNumber;

                return (
                  <li
                    key={pageNumber}
                    className={`page-item ${isActive ? "active" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                );
              })}

              {/* Next Button */}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  &raquo;
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
}
